import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { BusinessLogo } from "../../../images";

const MOCK_USER = {
  username: "ngxtradebot",
  password: "12345abc",
};

export default function TraderbotSignIn() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [remember, setRemember] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    setError("");

    if (!email.trim() || !password.trim()) {
      setError("Please fill in all fields.");
      return;
    }

    if (email === MOCK_USER.username && password === MOCK_USER.password) {
      navigate("/ngx-whatsapp-bot");
    } else {
      setError("Invalid credentials. Please try again.");
    }
  };

  return (
    <div className="font-['Source_Sans_3',_'Manrope',_sans-serif] text-gray-900 bg-white min-h-screen flex flex-col md:flex-row box-border">
      {/* LEFT — FORM */}
      <div className="flex-1 flex flex-col py-6 px-5 md:px-10 relative">
        <div
          className="flex items-center gap-2 font-bold text-base cursor-pointer text-gray-900 mb-10"
          onClick={() => navigate("/traderbot-by-ngx")}
        >
          <img
            src={BusinessLogo}
            alt="Traderbot"
            className="w-8 h-8 rounded-full"
          />
          <span className="text-xl">Traderbot by NGX</span>
        </div>

        <div className="max-w-[420px] mx-auto w-full relative">
          {/* Logo with concentric rings */}
          <div className="mt-16 mb-5 mx-auto flex items-center justify-center w-[160px] h-[160px]">
            <div className="flex items-center justify-center w-[120px] h-[120px] rounded-full bg-gradient-to-b from-[#e3e4e7] to-[#71778400]">
              <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center">
                <img src={BusinessLogo} alt="" className="w-9 h-9" />
              </div>
            </div>
          </div>

          <h2 className="text-2xl font-bold mb-1.5 text-center text-black">
            Sign In to your account
          </h2>
          <p className="text-base text-[#222222] text-center mb-5">
            Enter your details to login.
          </p>

          <hr className="border-0 border-t border-gray-200 mb-6" />

          {error && (
            <div className="bg-red-50 border border-red-200 text-red-600 py-2.5 px-3.5 rounded-lg text-sm mb-4 text-center">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <label className="block text-sm font-semibold text-gray-700 mb-1.5">
              Username <span className="text-red-600">*</span>
            </label>
            <div className="flex items-center border border-gray-300 rounded-lg px-3 mb-4 bg-white transition-colors focus-within:border-green-600 focus-within:ring-[3px] focus-within:ring-green-600/10">
              <span className="flex items-center mr-2">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#9ca3af"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                  <polyline points="22,6 12,13 2,6" />
                </svg>
              </span>
              <input
                type="text"
                placeholder="Username"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="flex-1 border-none outline-none py-3 text-sm bg-transparent font-inherit text-gray-900 placeholder:text-gray-400"
              />
            </div>

            <label className="block text-sm font-semibold text-gray-700 mb-1.5">
              Password
            </label>
            <div className="flex items-center border border-gray-300 rounded-lg px-3 mb-4 bg-white transition-colors focus-within:border-green-600 focus-within:ring-[3px] focus-within:ring-green-600/10">
              <span className="flex items-center mr-2">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#9ca3af"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                  <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                </svg>
              </span>
              <input
                type={showPassword ? "text" : "password"}
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="flex-1 border-none outline-none py-3 text-sm bg-transparent font-inherit text-gray-900 placeholder:text-gray-400"
              />
              <button
                type="button"
                className="bg-transparent border-none cursor-pointer p-1 flex items-center"
                onClick={() => setShowPassword(!showPassword)}
                aria-label="Toggle password visibility"
              >
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#9ca3af"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  {showPassword ? (
                    <>
                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                      <circle cx="12" cy="12" r="3" />
                    </>
                  ) : (
                    <>
                      <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94" />
                      <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19" />
                      <line x1="1" y1="1" x2="23" y2="23" />
                      <path d="M14.12 14.12a3 3 0 1 1-4.24-4.24" />
                    </>
                  )}
                </svg>
              </button>
            </div>

            <div className="flex justify-between items-center mb-5">
              <label className="flex items-center gap-1.5 text-[14px] text-gray-700 cursor-pointer">
                <input
                  type="checkbox"
                  checked={remember}
                  onChange={(e) => setRemember(e.target.checked)}
                  className="accent-green-600 w-4 h-4"
                />
                <span>Remember me</span>
              </label>
              <button
                type="button"
                className="bg-transparent border-none text-[#1CAB5F] text-[13px] font-semibold cursor-pointer hover:underline"
              >
                Forgot password?
              </button>
            </div>

            <button
              type="submit"
              className="w-full py-2.5 bg-[#76B82A] text-white border-none rounded-[10px] text-base font-semibold cursor-pointer transition-colors hover:bg-[#96e245]"
            >
              Sign In
            </button>
          </form>
        </div>
      </div>

      {/* RIGHT — IMAGE */}
      <div className="flex-1 relative overflow-hidden hidden md:block">
        <img
          src="https://res.cloudinary.com/analytics-intelligence/image/upload/v1774861677/ngx/Rectangle_8_cqnccz.png"
          alt="woman holding phone"
        />
      </div>
    </div>
  );
}
